// extracted by mini-css-extract-plugin
module.exports = {"region":"region-module__region--3oxZd","flag":"region-module__flag--3oyOH","flagIcon":"region-module__flagIcon--LXnSU","name":"region-module__name--1DEkK"};